import { useEffect } from "react";
import { Link } from "react-router-dom";
import { MessageSquareText } from "lucide-react";
import Logo from "./Logo";
import Footer from "./Footer";
import { SMS_CONSENT_TEXT, SMS_PROGRAM, UPDATED } from "../data/legalContent";

const field = "mt-1.5 w-full rounded-2xl border border-gray-200 bg-[#F7FAF8] px-4 py-3 text-[15px] text-[#829C8D]";

const OptInExample = () => (
  <figure className="mt-8 rounded-3xl border border-gray-100 bg-white p-6 shadow-[0_20px_60px_-30px_rgba(18,33,24,0.35)] sm:p-8" data-testid="sms-optin-example">
    <figcaption className="text-xs font-bold uppercase tracking-wider text-[#189346]">Extrait du formulaire d’inscription</figcaption>
    <p className="mt-3 font-display text-xl font-bold text-[#122118]">Créer votre compte famille</p>
    <label className="mt-4 block text-sm font-semibold text-[#122118]">Votre numéro (facultatif)</label>
    <div className={field}>(514) 555-0123</div>
    <div className="mt-4 flex items-start gap-3 text-sm leading-snug text-[#4a5f53]">
      <span className="mt-0.5 h-4 w-4 shrink-0 rounded border border-gray-300 bg-white" aria-label="Case non cochée par défaut" />
      <span data-testid="sms-optin-text">{SMS_CONSENT_TEXT}</span>
    </div>
    <div className="mt-3 flex items-start gap-3 text-sm leading-snug text-[#4a5f53]">
      <span className="mt-0.5 h-4 w-4 shrink-0 rounded border border-gray-300 bg-white" aria-label="Case non cochée par défaut" />
      <span data-testid="terms-optin-text">
        J’accepte la <Link to="/confidentialite" className="font-medium text-[#189346] underline">politique de confidentialité</Link> et les{" "}
        <Link to="/conditions-utilisation" className="font-medium text-[#189346] underline">conditions d’utilisation</Link>.
      </span>
    </div>
    <p className="mt-4 text-xs text-[#829C8D]">
      Les deux cases sont vides par défaut et distinctes : la case textos est facultative.
    </p>
  </figure>
);

export default function SmsConsentPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[#F7FAF8]" data-testid="sms-consent-page">
      <header className="border-b border-gray-100 bg-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-5">
          <Link to="/" aria-label="Accueil"><Logo /></Link>
          <Link to="/" className="text-sm font-semibold text-[#189346] hover:underline">Retour à l’accueil</Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-12 sm:py-16">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#E9FBF0] text-[#189346]">
          <MessageSquareText className="h-5 w-5" />
        </span>
        <h1 className="mt-4 font-display text-4xl font-bold text-[#122118] sm:text-5xl">{SMS_PROGRAM.title}</h1>
        <p className="mt-3 text-sm text-[#829C8D]">Dernière mise à jour : {UPDATED}</p>
        <p className="mt-6 text-base leading-relaxed text-[#2d5a3d]">{SMS_PROGRAM.intro}</p>
        <OptInExample />
        <figure className="mt-6" data-testid="sms-optin-screenshot">
          <img src="/sms-optin-form.jpg" alt="Capture du formulaire d’inscription Plan Étude avec la case de consentement aux textos non cochée" className="w-full rounded-2xl border border-gray-100" />
          <figcaption className="mt-2 text-xs text-[#829C8D]">Capture du formulaire réel « Créer votre compte famille ».</figcaption>
        </figure>
        {SMS_PROGRAM.sections.map((section) => (
          <section key={section.title} className="mt-10">
            <h2 className="font-display text-base font-bold text-[#122118] md:text-lg">{section.title}</h2>
            <ul className="mt-3 space-y-2">
              {section.body.map((line) => (
                <li key={line} className="text-sm leading-relaxed text-[#4a5f53] sm:text-base">{line}</li>
              ))}
            </ul>
          </section>
        ))}
      </main>
      <Footer />
    </div>
  );
}
